import React from 'react';

import classNames from 'classnames';
import { useMeasure } from 'react-use';

import useDarkMode from '../../hooks/useDarkMode';

const Footer = () => {
	const [ref, { height }] = useMeasure();

	const root = document.documentElement;
	root.style.setProperty('--footer-height', `${height}px`);

	const { darkModeStatus } = useDarkMode();

	return (
		<footer className='footer' ref={ref}>
			<div className='container-fluid'>
				<div className='row'>
					<div className='col'>
						<span className='fw-light'>Mirath.io & Memori.io Copyright © 2022</span>
					</div>
					<div className='col-auto'>
						<a
							className={classNames('text-decoration-none', {
								'link-dark': !darkModeStatus,
								'link-light': darkModeStatus,
							})}
							href='/'
						>
							<small className='fw-bold'>managed by Synomus.io</small>
						</a>
					</div>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
